// @ts-nocheck - AsyncTypeahead / form
import React, { useState, useRef } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { moveKeysBetweenRequests } from '../../actions/keyCodeActions';
import { searchRequests } from '../../api/searchApi';
import { useForm } from 'react-hook-form';
import KwPanel from '../common/KwPanel';
import ActionBar from '../layout/ActionBar';
import Request from '../layout/menu-components/SearchResults/Request';
import FormGroup from '../common/FormGroup';
import FormTextArea from '../common/FormTextArea';
import ResponsiveActionBarButtons from '../common/ResponsiveActionBarButtons';
import Button from '../common/Button';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';

function MoveKeysBetweenRequests() {
  usePageTitle(['Move keys between requests', 'Keys']);
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const sourceTypeaheadRef = useRef<any>(null);
  const destinationTypeaheadRef = useRef<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState<any[]>([]);

  const [keyform, setKeyForm] = useState<{
    sourceKeyRequestId: string | null;
    destinationKeyRequestId: string | null;
    reason: string;
  }>({
    sourceKeyRequestId: null,
    destinationKeyRequestId: null,
    reason: '',
  });

  const onSubmit = () => {
    if (!keyform.sourceKeyRequestId) {
      toast.error(t('Source request is required'));
      return;
    }
    if (!keyform.destinationKeyRequestId) {
      toast.error(t('Destination request is required'));
      return;
    }
    moveKeysBetweenRequests(keyform)
      .then(() => {
        toast.success(t('Keys moved'));
      })
      .catch((e: Error) => {
        toast.error(e.message || t('Failed to move keys'));
      });
  };

  const handleSearch = (query: string) => {
    setIsLoading(true);
    searchRequests(query)
      .then((items) => {
        setOptions(items);
        setIsLoading(false);
      })
      .catch(() => {
        setOptions([]);
        setIsLoading(false);
      });
  };

  const filterBy = () => true;

  const renderResult = (option: any, props: any) => {
    switch (option.resultType) {
      case 2:
        return <Request option={option} />;
      default:
        return <span>{option.title}</span>;
    }
  };

  const handleOnSourceChange = (selected: any[]) => {
    if (selected && selected.length > 0) {
      setKeyForm({ ...keyform, sourceKeyRequestId: selected[0].id });
    }
  };

  const handleOnDestinationChange = (selected: any[]) => {
    if (selected && selected.length > 0) {
      setKeyForm({ ...keyform, destinationKeyRequestId: selected[0].id });
    }
  };

  return (
    <>
      <ActionBar>
        <ResponsiveActionBarButtons
          buttons={[
            <Button
              key="move"
              text={t('Move')}
              className="btn btn-primary ms-2"
              onClick={handleSubmit(onSubmit)}
            />,
          ]}
        />
      </ActionBar>
      <KwPanel className="pb-3 pt-1">
        <FormGroup label={t('Source request')}>
          <AsyncTypeahead
            required
            className="required"
            ref={sourceTypeaheadRef}
            filterBy={filterBy}
            id="search-source-typeahead"
            isLoading={isLoading}
            labelKey="title"
            minLength={3}
            onSearch={handleSearch}
            options={options}
            placeholder={t('Search')}
            renderMenuItemChildren={renderResult}
            onChange={handleOnSourceChange}
          />
        </FormGroup>
        <FormGroup label={t('Destination request')}>
          <AsyncTypeahead
            required
            className="required"
            ref={destinationTypeaheadRef}
            filterBy={filterBy}
            id="search-destination-typeahead"
            isLoading={isLoading}
            labelKey="title"
            minLength={3}
            onSearch={handleSearch}
            options={options}
            placeholder={t('Search')}
            renderMenuItemChildren={renderResult}
            onChange={handleOnDestinationChange}
          />
        </FormGroup>

        <FormTextArea
          register={register}
          required
          error={errors.reason}
          errorMessage={t('Required')}
          name="reason"
          label={t('Please provide a reason')}
          placeholder=""
          defaultValue={keyform.reason}
        />
      </KwPanel>
    </>
  );
}

export default MoveKeysBetweenRequests;
